import React from 'react';
import "../less/a-business.less"
import hero_img from '../img/hero_img.png';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import advantagesItemsData from '../enums/advantages_items.json';
import { Preloader } from 'MWComponents';
import hero_data from '../enums/hero_data.json';
import additionalCardsData from '../enums/additional_cards_data.json';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import { canUseDOM } from '../../../../../helpers/canUseDOM';
import DOMPurify from 'utils/sanitize';
import { getSafeLinkProps } from '../../../../../helpers/utils/urlSecurity';
import { aBank24forBusiness } from '../../../../../services/urls/urls';

export default function template() {
    const imagesMap = {
      advantages_img_1,
      advantages_img_2,
      advantages_img_3,
      advantages_img_4
    };

    const handlersMap = {
      aBusinessLink: aBank24forBusiness
    };

    const advantagesItems = advantagesItemsData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const additionalCards = additionalCardsData.map(item => ({
      ...item,
      link: handlersMap[item.link]
    }));

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        href: handlersMap[hero_data.link.href],
      },
    };

    const universalWidget = this.widgetsHelper.getWidget.call(this, "universal_element");
    const universalWidgetData = (universalWidget && universalWidget.data) || [];

    return (
        <div className="module-business-a-business">
          <Hero
            data={heroData}
            img={hero_img}
          />
          <div className="content">
            <Advantages
              items={advantagesItems}
              title={'BUSINESS_ABUSINESS_ADVANTAGES_TITLE'}
            />
            {this.state.loader ? (canUseDOM ? <Preloader /> : null) : universalWidgetData && universalWidgetData.length ? (
              <div className="chapters-block">
                <div className="container">
                  <div className="chapters-block__body">
                    <h2 className="chapters-block__title">{this.l10n('BUSINESS_ABUSINESS_CHAPTERS_BLOCK_TITLE')}</h2>
                    <div className="chapters-block__row">
                      {[...universalWidgetData].sort((a, b) => Number(b.order) - Number(a.order)).map((item) => (
                        <a
                          key={item.id}
                          className="chapters-block__item"
                          {...getSafeLinkProps(item.attached_file_url)}
                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.attached_file_name)}}
                        >
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            <AdditionalProduct
              items={additionalCards}
            />
          </div>
        </div>
    );
}
